import dataMap from './data.js'
import Config from '@/config'

const developmentOrigin = 'https://remote-sales-prp.balenciaga.cn'
export const getLocationOrigin = () => {
  if (Config.isDevelopment) {
    return developmentOrigin
  }
  return location.origin
}

export const getTenantBaseConfig = () => {
  if (Config.isDevelopment) {
    // return dataMap.get("https://cus-remotesales-dev.linkioapp.com");
    return dataMap.get(getLocationOrigin())
  }
  return dataMap.get(location.origin)
}

export const getPublicOssUrl = filename => {
  if (!filename) return ''
  if (!filename.includes('PUBLIC')) return filename
  const locationOrigin = getLocationOrigin()
  const { publicOssPrefix } = getTenantBaseConfig()
  return `${locationOrigin}/${publicOssPrefix}/${filename}`
}
